import { customersCollection } from '../firebase';
import store from './../store';

export default function UsersIntegration(agreementData,currentPage) {
	return class UsersIntegration {
		constructor(editor) {
			this.editor = editor;
		}

		async init() {
			const usersPlugin = this.editor.plugins.get('Users');

			usersPlugin.addUser({
				id: store.state.user.uid,
				name: [store.state.user.displayName, store.state.user.lastName].filter(Boolean).join(' ') || store.state.user.email
			});
			usersPlugin.defineMe(store.state.user.uid);
			const trackedChanges = agreementData.trackedChanges;
			const allComments = agreementData.comments;
			const summaryTrackedChanges = agreementData.summaryTrackedChanges;
			const summaryAllComments = agreementData.summaryComments;

			const fetchAndAddUser = async (userId) => {
				if (!usersPlugin.getUser(userId)) {
					try {
						const userDoc = await customersCollection
							.doc(userId)
							.get();
						if (userDoc.exists) {
							const userData = userDoc.data();
							const userDetails = {
								id: userId,
								name: [userData.displayName, userData.lastName].filter(Boolean).join(' ') || userData.email,
							};
							if (!usersPlugin.getUser(userId)) {
								usersPlugin.addUser(userDetails);
							} else {
								return;
							}
						} else {
							console.error(
								`User with ID ${userId} does not exist.`
							);
						}
					} catch (error) {
						console.error(
							`Error fetching user with ID ${userId}:`,
							error
						);
					}
				}
			};

			if(currentPage === 'editor'){
				for (const change of trackedChanges) {
					await fetchAndAddUser(change.authorId);
				}
	
				for (const thread of allComments) {
					for (const comment of thread.comments) {
						await fetchAndAddUser(comment.authorId);
					}
				}
			}
			else if(currentPage === 'summary'){
				for (const change of summaryTrackedChanges) {
					await fetchAndAddUser(change.authorId);
				}
	
				for (const thread of summaryAllComments) {
					for (const comment of thread.comments) {
						await fetchAndAddUser(comment.authorId);
					}
				}
			}
		}
	};
}